import { Flex } from 'rebass';
import styled from 'styled-components';

import { theme } from '../../styles/theme';

export const Wrapper = styled(Flex)`
  @media (min-width: ${theme.breakpoint.lg}) {
    ${({ $hideDesktop }) => ($hideDesktop ? 'display: none;' : '')}
  }
  @media (max-width: ${theme.breakpoint.lg}) {
    ${({ $hideMobile }) => ($hideMobile ? 'display: none;' : '')}
  }
`;

export const ContentWrapper = styled(Flex)`
  &&& > *,
  &&& > * > .gatsby-image-wrapper {
    width: 100%;
  }
`;
